// extracted by mini-css-extract-plugin
module.exports = {"slider":"styles_slider__3nnBT","arrow":"styles_arrow__2bCSs","container":"styles_container__1x4TX"};